"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function attachListeners(player, onPlaying, onError) {
  var IVSPackage = window.IVSPlayer;
  var ErrorType = IVSPackage.ErrorType,
    PlayerEventType = IVSPackage.PlayerEventType,
    PlayerState = IVSPackage.PlayerState;
  var _loop = function _loop() {
    var state = _Object$values[_i];
    player.addEventListener(state, function () {
      if (state === 'Ready' && onPlaying) onPlaying();
      ivsLog(state);
    });
  };
  for (var _i = 0, _Object$values = Object.values(PlayerState); _i < _Object$values.length; _i++) {
    _loop();
  }
  player.addEventListener(PlayerEventType.INITIALIZED, function () {
    ivsLog('INITIALIZED');
  });
  player.addEventListener(PlayerEventType.ERROR, function (error) {
    var statusTooManyRequests = 429;
    if (error.type === ErrorType.NOT_AVAILABLE && error.code === statusTooManyRequests) {
      ivsError('Concurrent-viewer limit reached', error);
    } else {
      ivsError(error);
    }
    if (onError) onError(error);
  });
  player.addEventListener(PlayerEventType.QUALITY_CHANGED, function (quality) {
    ivsLog('QUALITY_CHANGED', quality);
  });

  // This event fires when text cues are encountered, such as captions or subtitles
  player.addEventListener(PlayerEventType.TEXT_CUE, function (cue) {
    ivsLog('TEXT_CUE', cue.startTime, cue.text);
  });

  // This event fires when embedded Timed Metadata is encountered
  player.addEventListener(PlayerEventType.TEXT_METADATA_CUE, function (cue) {
    ivsLog('Timed metadata', cue.text);
  });
}
function ivsLog() {
  customLog('log', 'IVS Player: ', Array.from(arguments));
}
function ivsError() {
  customLog('error', 'IVS Player Error: ', Array.from(arguments));
}
function customLog(level, prefix, messages) {
  messages.unshift(prefix);
  console[level].apply(console, messages);
}
var _default = exports["default"] = attachListeners;